import React from 'react';
import __ from 'utils/i18n';
import { MOVEMENT_CONCEPTS } from '../../constants';

export const ConceptCell = ({ cell }) => {
  const { conceptLabel, amount, description } = cell.original;
  
  // Corregir el concepto para retiros manuales
  // Si el concepto es "Retiro automático" pero la descripción contiene "MANUAL",
  // entonces es un retiro manual
  let displayConceptLabel = conceptLabel;
  if (
    (conceptLabel === MOVEMENT_CONCEPTS.CASHOUT || conceptLabel === 'Retiro automático') &&
    description &&
    description.toUpperCase().includes('MANUAL')
  ) {
    displayConceptLabel = MOVEMENT_CONCEPTS.ATM; // 'Retiro manual'
  }
  
  // Basarse en el signo del monto para determinar si es crédito o débito:
  // - Monto positivo = dinero que ENTRA (crédito)
  // - Monto negativo = dinero que SALE (débito)
  const isCredit = amount?.amount > 0;
  const entryType = isCredit ? 'credit' : 'debit';
  
  const entryTypeLabel = isCredit
    ? __('dashboard.sections.movements.entryType.credit')
    : __('dashboard.sections.movements.entryType.debit');
  
  return (
    <div className="concept-cell">
      <span className="concept-label">{displayConceptLabel}</span>
      <span className={`entry-type ${entryType}`}>{entryTypeLabel}</span>
    </div>
  );
};